
import { Component, Vue } from 'vue-property-decorator';
import OsReportsOverview from '@/components/shared/reports/OsReportsOverview.vue';
import OsReportContentCategoriesOverview from '@/components/shared/reportcontentcategories/OsReportContentCategoriesOverview.vue';
import OsInternalUsersOverview from '@/components/shared/internalusers/OsInternalUsersOverview.vue';
import { IAppuser } from '@/models/application';
@Component({
  components: {
    OsInternalUsersOverview,
    OsReportContentCategoriesOverview,
    OsReportsOverview
  }
})
export default class ReportContentCategoriesIndex extends Vue {
  openExisting(selected: IAppuser) {
    this.$router.push(`/settings/reportcontentcategories/${selected.id}`);
  }
  openCreateForm() {
    this.$router.push(`/settings/reportcontentcategories/create`);
  }
}
